import { useState } from "react";
import { api, ApiError, type Kayttaja } from "./api";
import { t, virheTeksti } from "./kieli";

/* ═══════════════════════════════════════════════════════════
   Kenttätilin pakotettu PIN-vaihto (168, Toni 24.9.2026).

   Näytetään kun `kayttaja.pinVaihdettava`: PIN on luonnissa tai
   nollauksessa pääkäyttäjän asettama, eikä tunnuksella tehdä mitään
   ennen omaa vaihtoa. Palvelin pitää saman portin (403
   `pin_vaihdettava`) — tämä näkymä on apu, ei portti.
   ═══════════════════════════════════════════════════════════ */

export default function PinVaihto({ kayttaja, valmis }: { kayttaja: Kayttaja; valmis: () => void }) {
  const [nykyinen, setNykyinen] = useState("");
  const [uusi, setUusi] = useState("");
  const [toisto, setToisto] = useState("");
  const [virhe, setVirhe] = useState<{ kentta: string; viesti: string } | null>(null);
  const [tallennetaan, setTallennetaan] = useState(false);

  async function laheta(e: React.FormEvent) {
    e.preventDefault();
    if (!/^[0-9]{4}$/.test(uusi)) { setVirhe({ kentta: "uusi", viesti: t("pin.nelja_numeroa") }); return; }
    if (uusi !== toisto) { setVirhe({ kentta: "toisto", viesti: t("pin.ei_tasmaa") }); return; }
    setTallennetaan(true); setVirhe(null);
    try { await api.omaPin(nykyinen, uusi); valmis(); }
    catch (err) {
      const kentta = err instanceof ApiError && err.kentta ? err.kentta : "nykyinen";
      setVirhe({ kentta, viesti: err instanceof ApiError ? virheTeksti(err.virhe, err.message) : t("pin.vaihto_virhe") });
    }
    finally { setTallennetaan(false); }
  }

  const kentta = (nimi: string, otsikko: string, arvo: string, aseta: (v: string) => void) => (
    <label>{otsikko}
      <input type="password" inputMode="numeric" autoComplete={nimi === "nykyinen" ? "current-password" : "new-password"}
             maxLength={4} value={arvo} data-pin={nimi} aria-invalid={virhe?.kentta === nimi}
             onChange={(e) => aseta(e.target.value.replace(/[^0-9]/g, ""))} />
      {virhe?.kentta === nimi && <span className="kenttavirhe" role="alert" data-kenttavirhe={nimi}>{virhe.viesti}</span>}
    </label>
  );

  return (
    <main className="kirjautuminen" data-pin-vaihto="">
      <section className="panel lomake">
        <div className="panel__head"><h1>{t("pin.vaihda")}</h1></div>
        <p>
          {t("pin.ohje", { nimi: kayttaja.nimi })}
        </p>
        <form onSubmit={laheta} noValidate>
          {kentta("nykyinen", t("pin.nykyinen"), nykyinen, setNykyinen)}
          {kentta("uusi", t("pin.uusi"), uusi, setUusi)}
          {kentta("toisto", t("pin.toisto"), toisto, setToisto)}
          <button type="submit" className="nappi nappi--paa" disabled={tallennetaan} data-pin-tallenna="">
            {tallennetaan ? t("pin.vaihdetaan") : t("pin.vaihda")}
          </button>
        </form>
        <button type="button" className="nappi nappi--kevyt" onClick={() => api.kirjauduUlos().finally(() => location.reload())}>
          {t("yla.kirjaudu_ulos")}
        </button>
      </section>
    </main>
  );
}
